
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"73","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.484 9.41H8.968c-.784 0-1.42-.64-1.42-1.43 0-.79.636-1.432 1.42-1.432h23.516c.784 0 1.42.641 1.42 1.432 0 .79-.634 1.43-1.42 1.43zM40.778 15.653H1.42c-.784 0-1.42-.641-1.42-1.431s.636-1.431 1.42-1.431h39.358c.784 0 1.42.64 1.42 1.43 0 .79-.636 1.432-1.42 1.432zM33.44 21.896H8.498c-.784 0-1.42-.642-1.42-1.432 0-.79.636-1.431 1.42-1.431h24.944c.784 0 1.42.641 1.42 1.431s-.636 1.432-1.422 1.432zM20.182 28.138H4.99c-.784 0-1.42-.641-1.42-1.431s.636-1.432 1.42-1.432h15.193c.785 0 1.42.642 1.42 1.432 0 .79-.636 1.43-1.42 1.43z","fill":"#0183FE"}}),_c('path',{attrs:{"d":"M42.236 33.531c-.435 0-.873-.168-1.204-.504a1.725 1.725 0 010-2.43L54.68 16.847 40.87 2.932a1.725 1.725 0 010-2.43 1.698 1.698 0 012.412 0l15.015 15.13c.665.67.665 1.758 0 2.43L43.445 33.026a1.7 1.7 0 01-1.209.504z","fill":"#0183FE"}}),_c('path',{attrs:{"d":"M55.442 34c-.435 0-.873-.167-1.204-.503a1.729 1.729 0 010-2.43l13.648-13.752-13.81-13.914a1.729 1.729 0 010-2.43 1.698 1.698 0 012.412 0l15.015 15.13c.665.67.665 1.758 0 2.43L56.651 33.497a1.704 1.704 0 01-1.209.504z","fill":"#0183FE"}})])
          )
        }
      }
    